// import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import { navtoggle } from "../../../store/actions/AuthActions";

// import logo from "../../../assets/images/logo.png";

// const NavHader = () => {
//   const dispatch = useDispatch();
//   const sideMenu = useSelector((state) => state.sideMenu);

//   console.log("NavHader - sideMenu state:", sideMenu);

//   const handleToggle = () => {
//     console.log("NavHader - handleToggle called, current state:", sideMenu);
//     dispatch(navtoggle());
//   };

//   return (
//     <div className="nav-header d-flex align-items-center justify-content-between px-3 py-2">
//       {/* Brand Logo */}
//       <Link to="/" className="brand-logo d-flex align-items-center">
//         <img
//           src={logo}
//           alt="Logo"
//           className="logo"
//           style={{
//             height: "48px", // Increased for better desktop visibility
//             maxHeight: "60px",
//             width: "auto",
//             objectFit: "contain",
//           }}
//         />
//       </Link>

//       {/* Hamburger Menu */}
//       <div className="nav-control" onClick={handleToggle}>
//         <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
//           <span className="line" />
//           <span className="line" />
//           <span className="line" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NavHader;
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { navtoggle } from "../../../store/actions/AuthActions";
import logo from "../../../assets/images/logo.png";

const NavHader = () => {
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);

  const location = useLocation();
  const pathname = location.pathname;

  // Check Case Paper page
  const isCasePaperPage = pathname.includes("/case-paper");

  const handleToggle = () => {
    if (!isCasePaperPage) dispatch(navtoggle());
  };

  return (
    <div className="nav-header d-flex align-items-center justify-content-between px-3 py-2">
      
      {/* Logo with bigger size on Case Paper */}
      <Link to="/" className="brand-logo d-flex align-items-center">
        <img
          src={logo}
          alt="Logo"
          className="logo"
          // style={{
          //   height: isCasePaperPage ? "60px" : "48px",
          //   maxHeight: isCasePaperPage ? "80px" : "60px",
          //   width: "auto",
          //   objectFit: "contain",
          // }}
          style={{
            height: isCasePaperPage ? "130px" : "48px",
            maxHeight: isCasePaperPage ? "170px" : "60px",
            width: isCasePaperPage ? "150px" : "100px", // set width explicitly
            objectFit: "contain",
          }}
        
        />
      </Link>

      {/* Hide hamburger menu for case-paper */}
      {!isCasePaperPage && (
        <div className="nav-control" onClick={handleToggle}>
          <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </div>
        </div>
      )}
    </div>
  );
};

export default NavHader;
